'use client';
import React, { createContext, use } from 'react';

import { InputTheme } from './use-input-theme.types';

const InputThemeContext = createContext<InputTheme | undefined>(undefined);

export const useInputTheme = () => use(InputThemeContext);

export function InputThemeProvider({
  children,
  theme,
}: {
  children: React.ReactNode;
  theme: InputTheme;
}) {
  return <InputThemeContext value={theme}>{children}</InputThemeContext>;
}
